<footer class="py-12 md:py-28 bg-black flex flex-col gap-8 md:gap-10 px-4 md:px-0">
    <div class="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-0">
        <img src="/assets/icons/drazamed_new_light.svg" alt="Drazamed" class="w-32 md:w-40! md:col-start-2 md:col-span-3">
        <div class="md:col-start-6 md:col-span-2 flex flex-col gap-4">
            <p class="text-white uppercase text-sm! font-medium!">Plataforma</p>
            <small class="text-text-tertiary cursor-pointer hover:text-white" routerLink="/">Inicio</small>
            <small class="text-text-tertiary cursor-pointer hover:text-white" routerLink="/features">Producto</small>
            <small class="text-text-tertiary cursor-pointer hover:text-white" routerLink="/contact">Contacto</small>
        </div>
    
        <div class="md:col-start-8 md:col-span-2 flex flex-col gap-4">
            <p class="text-white uppercase text-sm! font-medium!">Contacto</p>
            <small class="text-text-tertiary cursor-pointer hover:text-white">Instagram</small>
            <small class="text-text-tertiary cursor-pointer hover:text-white">Facebook</small>
        </div>
    
        <div class="md:col-start-10 md:col-span-2 flex flex-col gap-4">
            <p class="text-white uppercase text-sm! font-medium!">Legal</p>
            <small class="text-text-tertiary cursor-pointer hover:text-white" routerLink="/terms">Términos de uso</small>
            <small class="text-text-tertiary cursor-pointer hover:text-white" routerLink="/privacy">Política de privacidad</small>
        </div>
    </div>

    <div class="pt-6 md:pt-10 grid grid-cols-1 md:grid-cols-12 px-4 md:px-0">
        <p class="md:col-start-2 md:col-span-10 border-t border-gray-600 pt-6 md:pt-10 text-text-tertiary text-sm! text-center md:text-left">© 2026 SP innova. Todos los derechos reservados.</p>
    </div>

</footer>
